import { axiosInstance } from "../config/axios";

// Backend endpoints for PopupCollection / PlayOffPopup / PopupCollectionImage
const endpoint = "popup-collections/";
const popupEndpoint = "playoff-popups/";
const imageEndpoint = "popup-collection-images/";

export const COLLECTION_TYPES = [
	{ value: "edit", label: "Edit" },
	{ value: "need", label: "Need" },
];

export const getPopupCollections = async (
	page_size = 10,
	page = 1,
	filters = {},
) => {
	const res = await axiosInstance.get(endpoint, {
		params: { page_size, page, ...filters },
	});

	return res.data;
};

export const getPopupCollection = async (id) => {
	const res = await axiosInstance.get(`${endpoint}${id}/`);
	return res.data;
};

export const createPopupCollection = (data) =>
	axiosInstance.post(endpoint, data);

export const updatePopupCollection = (id, data) =>
	axiosInstance.patch(`${endpoint}${id}/`, data);

export const deletePopupCollection = (id) =>
	axiosInstance.delete(`${endpoint}${id}/`);

export const getPopups = async (search = "", page_size = 20) => {
	const res = await axiosInstance.get(popupEndpoint, {
		params: { page_size, page: 1, search },
	});

	return res.data;
};

export const uploadPopupCollectionImage = async (file) => {
	const formData = new FormData();
	formData.append("file", file);

	const res = await axiosInstance.post(imageEndpoint, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return res.data;
};
